import { getExternalServiceUrl, isProduction, isStaging } from './environment';

/**
 * If the client user's team uses omni by default, redirect from app.beatly.com to omni.
 * No-op when already on omni, on localhost, or when the flag is off.
 * @returns true if a redirect was triggered (navigation in progress).
 */
export function redirectClientToOmniIfNeeded(user: Api.UserObject | undefined | null): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (!user?.is_client || !user.team?.has_omni_enabled) {
    return false;
  }
  if (!isProduction() && !isStaging()) {
    return false;
  }

  const omniOrigin = getExternalServiceUrl('omni');
  if (window.location.origin === omniOrigin) {
    return false;
  }

  const host = window.location.hostname;
  if (host !== 'app.beatly.com' && host !== 'app.staging.beatly.com') {
    return false;
  }

  const dest = `${omniOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(dest);
  return true;
}
